var pug = require("!../../../../node_modules/.pnpm/pug@2.0.4/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (AccountActivityStatus, AccountInactiveCauseValue, comparisonDateRangeText, currentDateRangeText, gridData, hasError, i18n, index, loaded, metricName) {pug_mixins["entityName"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var isSearchTerm = item.typeName === 'SearchTerm';
var isAccount = item.typeName === 'Account';
var AccountActivityStatus = item.AccountActivityStatus;
if (isAccount) {
if (item.status === AccountActivityStatus.Errors) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-error-icon icon-error\""+pug.attr("title", item.i18n.getString('AccountStatus_Error'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else
if (item.status === AccountActivityStatus.Deleted) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-deleted-icon\""+pug.attr("title", item.i18n.getString('AccountStatus_Deleted'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
else
if (item.status === AccountActivityStatus.Enabled) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"account-enabled-icon icon-success\""+pug.attr("title", item.i18n.getString('AccountStatus_Active'), true, true)) + "\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (!isSearchTerm) {
pug_html = pug_html + "\u003Cdiv class=\"status\"\u003E";
if (item.status === 'Deleted') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusDeleted_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Paused') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusPaused_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Suspended') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusSuspended_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Draft') {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-paused-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusDraft_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
else
if (item.status === 'Expired') {
pug_html = pug_html + "\u003Cdiv class=\"statushypendisplay\"\u003E\u003C\u002Fdiv\u003E";
}
else {
if (item.isExperiment) {
pug_html = pug_html + "\u003Cdiv class=\"experiment-active-icon\"\u003E\u003C\u002Fdiv\u003E";
}
else {
pug_html = pug_html + "\u003Cdiv class=\"statusEnabled_icon\"\u003E\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Ca" + (pug.attr("href", item.hash, true, true)+pug.attr("title", item.hideToolTip ? '' : item.name, true, true)+pug.attr("aria-label", item.i18n.getString(`${item.rawStatus} {{entity}}`, {entity: item.name}), true, true)+pug.attr("data-campaignid", item.campaignId, true, true)+pug.attr("data-adgroupid", item.adGroupId, true, true)+pug.attr("data-accountid", item.accountId, true, true)+pug.attr("data-type", item.typeName, true, true)+pug.attr("data-text", item.text, true, true)+pug.attr("data-navigationLevel", item.navigationLevel, true, true)+pug.attr("data-campaigntype", item.campaignType, true, true)+pug.attr("data-rawstatus", item.rawStatus, true, true)+pug.attr("data-campaignName", item.campaignName, true, true)+pug.attr("data-adGoupName", item.adGroupName, true, true)+pug.attr("data-matchType", item.matchType, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
if (isAccount && item.status === 'Deleted') {
pug_html = pug_html + "\u003Cspan class=\"inactive\"\u003E" + (null == (pug_interp = `&nbsp(${item.i18n.getString('AccountStatus_InActive')})`) ? "" : pug_interp) + "\u003C\u002Fspan\u003E";
}
};
pug_mixins["insightHover"] = pug_interp = function(index){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"hover-container\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = "Click to view insight") ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["insightBulb"] = pug_interp = function(item){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["mcc-perf-fluctuation-bulb-container",item.rowClass], [false,true]), false, true)) + "\u003E";
if ((item.fluctuationTypeIds.length > 0)) {
pug_html = pug_html + "\u003Cdiv" + (" class=\"mcc-perf-fluctuation-bulb iconba iconba-Insights\""+" tabindex=\"0\""+pug.attr("data-rowIndex", item.index, true, true)+pug.attr("data-fluxTypeIds", item.fluctuationTypeIds, true, true)+pug.attr("data-metricName", item.metricName, true, true)+pug.attr("data-metricText", item.formattedValue, true, true)+pug.attr("data-cmid", item.campaignId, true, true)+pug.attr("data-aid", item.accountId, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"mcc-perf-fluctuation-placeholder\"\u003E\u003C\u002Fdiv\u003E";
if (item.fluctuationTypeIds.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"insight-hover-target\"\u003E";
pug_mixins["insightHover"]({ index, i18n });
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_mixins["emptyContent"] = pug_interp = function(i18n){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"top-change-empty\"\u003E" + (null == (pug_interp = i18n.getString('Dashboard_TopChangeCard_NoData')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
};
pug_mixins["errorContent"] = pug_interp = function(i18n){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"top-change-empty\"\u003E" + (null == (pug_interp = i18n.getString('Dashboard_Cards_Data_Error')) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
};
pug_mixins["kpi"] = pug_interp = function(kpiData, metricName, dateRangeText){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"kpi-date-range\"\u003E" + (pug.escape(null == (pug_interp = dateRangeText) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cspan\u003E" + (pug.escape(null == (pug_interp = metricName) ? "" : pug_interp)) + ": &nbsp\u003Cspan class=\"kpi-data\"\u003E" + (pug.escape(null == (pug_interp = kpiData) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E";
};
pug_mixins["hoverContent"] = pug_interp = function(i18n, item, metricName, currentDateRangeText, comparisonDateRangeText){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"hover-container\"\u003E\u003Cdiv class=\"hover-content\"\u003E\u003Cdiv class=\"entity-name\"\u003E" + (pug.escape(null == (pug_interp = item.name) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"kpi-grid\"\u003E\u003Cdiv class=\"kpi-current\"\u003E";
pug_mixins["kpi"](item.formattedMetrics, metricName, currentDateRangeText);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"kpi-comparison\"\u003E";
pug_mixins["kpi"](item.formattedPeriodMetrics, metricName, comparisonDateRangeText);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"kpi-change\"\u003E\u003Cdiv class=\"bar-icon\"\u003E\u003C\u002Fdiv\u003E\u003Cspan\u003E" + (null == (pug_interp = i18n.getString("Dashboard_Change")) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003Cspan class=\"kpi-data\"\u003E\u003Cspan\u003E&nbsp " + (pug.escape(null == (pug_interp = item.formattedValue) ? "" : pug_interp)) + "\u003C\u002Fspan\u003E\u003Cspan\u003E&nbsp (" + (pug.escape(null == (pug_interp = item.formattedPercentageValue) ? "" : pug_interp)) + ")\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
};
pug_mixins["gridRow"] = pug_interp = function(i18n, item, index, metricName, currentDateRangeText, comparisonDateRangeText, AccountInactiveCauseValue){
var block = (this && this.block), attributes = (this && this.attributes) || {};
var rowClass = "top-change-grid-row-" + (index+1)
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["top-change-entity-name",rowClass], [false,true]), false, true)) + "\u003E";
var nameCell = {};
nameCell.status = item.status;
nameCell.name = item.name;
nameCell.hash = item.hash;
nameCell.campaignId = item.campaignId;
nameCell.adGroupId = item.adgroupId;
nameCell.accountId = item.accountId;
nameCell.typeName = item.typeName;
nameCell.isExperiment = item.isExperiment;
nameCell.campaignType = item.campaignType;
nameCell.rawStatus = item.rawStatus;
nameCell.i18n = i18n;
nameCell.AccountActivityStatus = AccountActivityStatus;
pug_mixins["entityName"](nameCell);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["top-change-graph-decline",rowClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"decline-box\"\u003E\u003Cdiv" + (" class=\"graph-space\""+pug.attr("style", pug.style(`flex: ${item.declineSpace}`), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"graph-bar\""+pug.attr("style", pug.style(`flex: ${item.declineBar}`), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["top-change-graph-increase",rowClass], [false,true]), false, true)) + "\u003E\u003Cdiv class=\"increase-box\"\u003E\u003Cdiv" + (" class=\"graph-bar\""+pug.attr("style", pug.style(`flex: ${item.increaseBar}`), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv" + (" class=\"graph-space\""+pug.attr("style", pug.style(`flex: ${item.increaseSpace}`), true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
pug_mixins["insightBulb"]({ index, fluctuationTypeIds: item.fluctuationTypeIds, rowClass, metricName, formattedValue: item.formattedValue, campaignId: item.campaignId, accountId: item.accountId });
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["pop-change",rowClass], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.formattedValue) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["pop-change-percentage",rowClass], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.formattedPercentageValue) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["pop-range",rowClass], [false,true]), false, true)) + "\u003E" + (pug.escape(null == (pug_interp = item.fromTo) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
var classes = [rowClass]
if (item.declineBar > 0) {
classes.push('kpi-declined')
}
else
if (item.increaseBar > 0) {
classes.push('kpi-increased')
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["graph-hover-target",classes], [false,true]), false, true)) + "\u003E";
pug_mixins["hoverContent"](i18n, item, metricName, currentDateRangeText, comparisonDateRangeText);
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv" + (pug.attr("class", pug.classes(["pop-hover-target",classes], [false,true]), false, true)) + "\u003E";
pug_mixins["hoverContent"](i18n, item, metricName, currentDateRangeText, comparisonDateRangeText);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (loaded) {
if (hasError) {
pug_mixins["errorContent"](i18n);
}
else
if (gridData != undefined) {
if (gridData.length < 1) {
pug_mixins["emptyContent"](i18n);
}
else {
pug_html = pug_html + "\u003Cdiv class=\"top-change-grid\"\u003E";
// iterate gridData
;(function(){
  var $$obj = gridData;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var item = $$obj[index];
pug_mixins["gridRow"](i18n, item, index, metricName, currentDateRangeText, comparisonDateRangeText, AccountInactiveCauseValue);
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var item = $$obj[index];
pug_mixins["gridRow"](i18n, item, index, metricName, currentDateRangeText, comparisonDateRangeText, AccountInactiveCauseValue);
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"cover-container\"\u003E\u003Cdiv class=\"scroll-bar-cover\"\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
}
}
}}.call(this,"AccountActivityStatus" in locals_for_with?locals_for_with.AccountActivityStatus:typeof AccountActivityStatus!=="undefined"?AccountActivityStatus:undefined,"AccountInactiveCauseValue" in locals_for_with?locals_for_with.AccountInactiveCauseValue:typeof AccountInactiveCauseValue!=="undefined"?AccountInactiveCauseValue:undefined,"comparisonDateRangeText" in locals_for_with?locals_for_with.comparisonDateRangeText:typeof comparisonDateRangeText!=="undefined"?comparisonDateRangeText:undefined,"currentDateRangeText" in locals_for_with?locals_for_with.currentDateRangeText:typeof currentDateRangeText!=="undefined"?currentDateRangeText:undefined,"gridData" in locals_for_with?locals_for_with.gridData:typeof gridData!=="undefined"?gridData:undefined,"hasError" in locals_for_with?locals_for_with.hasError:typeof hasError!=="undefined"?hasError:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"index" in locals_for_with?locals_for_with.index:typeof index!=="undefined"?index:undefined,"loaded" in locals_for_with?locals_for_with.loaded:typeof loaded!=="undefined"?loaded:undefined,"metricName" in locals_for_with?locals_for_with.metricName:typeof metricName!=="undefined"?metricName:undefined));;return pug_html;};
module.exports = template;